import { coachDisplayName } from '@efdigital/ll-addon-coaching';
import { getSessionStatusDisplay } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-display';
import type { CoachingSession, CoachProfile } from '@efdigital/ll-addon-data';
import ActionRequiredDashboardRow from '@efdigital/ll-xceed-v2/components/coaching/action-required-dashboard-row.gts';
import type { TOC } from '@ember/component/template-only';

interface DashboardSessionRowSignature {
  Args: {
    session: CoachingSession;
    /** Omitted when the coach's published profile could not be resolved. */
    coach?: CoachProfile;
  };
  Element: HTMLDivElement;
}

function personLabel(
  coach: CoachProfile | undefined,
  session: CoachingSession
): string {
  if (coach) {
    return coachDisplayName(coach);
  }

  return session.user;
}

/**
 * Compact row for the coachee dashboard's "Need your attention" card — the
 * counterpart to the coach dashboard's, naming the coach rather than the
 * coachee and linking to the coachee's own action-required page.
 *
 * Deliberately not the SessionCard the action-required page uses: that one
 * carries the accept/decline controls, which belong on the page the row links
 * to rather than on a dashboard summary.
 */
const DashboardSessionRow: TOC<DashboardSessionRowSignature> = <template>
  {{#let (getSessionStatusDisplay @session.status) as |statusDisplay|}}
    <ActionRequiredDashboardRow
      @session={{@session}}
      @personLabel={{personLabel @coach @session}}
      @statusLabel={{statusDisplay.label}}
      @linkRoute="coaching.coachee.cohort.sessions.action-required"
      ...attributes
    />
  {{/let}}
</template>;

export default DashboardSessionRow;
